/** Runtime constants for record shapes, kept free of Zod so the apps stay small. */

export const PLACE_KINDS = [
  'airport',
  'lodging',
  'station',
  'port',
  'poi',
  'city',
  'address',
] as const;

export const ITEM_TYPES = [
  'flight',
  'lodging',
  'car',
  'train',
  'bus',
  'ferry',
  'cruise',
  'restaurant',
  'activity',
  'transfer',
  'parking',
  'other',
] as const;

export const PAID_WITH = ['cash', 'points', 'cert', 'mixed'] as const;

export const SOURCE_STATUSES = [
  'queued',
  'processing',
  'added',
  'needs_review',
  'needs_approval',
  'failed',
  'ignored',
] as const;

export const SYNC_TABLES = [
  'trips',
  'items',
  'places',
  'attachments',
  'sources',
  'itemChanges',
  'settings',
  'homeBases',
  'flightLive',
  'programs',
  'cards',
  'perks',
  'redemptions',
  'briefs',
  'balanceSnapshots',
] as const;

/** Tables added after the first Android builds: sent only to apps that ask for them. */
export const OPT_IN_TABLES = ['briefs', 'balanceSnapshots'] as const;

/** Tables the apps may write. The rest are written only by the server. */
export const CLIENT_WRITABLE_TABLES = [
  'trips',
  'items',
  'places',
  'attachments',
  'sources',
  'settings',
  'homeBases',
  'programs',
  'cards',
  'perks',
  'redemptions',
  'balanceSnapshots',
] as const;

/** Wallet tabs: transferable card points, hotels, airlines and everything else. */
export const POINTS_CATEGORIES = ['cards', 'hotels', 'airlines', 'other'] as const;

/** Where a logged balance came from. */
export const BALANCE_SOURCES = ['manual', 'mcp', 'backfill'] as const;

export const BENEFIT_PERIODS = [
  'monthly',
  'quarterly',
  'semiannual',
  'annual',
  'cardmember-year',
  'once',
  'ongoing',
] as const;

export const PERK_KINDS = [
  'credit',
  'certificate',
  'bonus',
  'upgrade',
  'voucher',
  'other',
] as const;
